import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { AtivoModel } from './AtivoModel';
import { DetalhesAtivoModel } from './DetalhesAtivoModel';
import { GraficoAtivoModel } from './GraficoAtivoModel';

export class RecomendacaoModel extends AtivoModel {

    titulo_estrategia: string

    listaRecomendacoes(mercado: String, limit: number, offset: number, filtro: String = '', tipoRecomendacao: number = null, estadoRecomendacoes: String = "abertas"): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/' + mercado + (tipoRecomendacao ? "/categorias/" + tipoRecomendacao : "") + `/${estadoRecomendacoes}/` + limit + '/' + offset + (filtro ? '/' + filtro : ''))
    }

    getAtivoPorId(idAtivo: Number): Promise<PhicubeResponse<DetalhesAtivoModel>> {
        return new GatewayService().requestGet('/api/recomendacoes/' + idAtivo)
    }

    getGraficoAtivoPorId(idAtivo: Number): Promise<PhicubeResponse<GraficoAtivoModel>> {
        return new GatewayService().requestGet('/api/recomendacoes/ativo/' + idAtivo + '/grafico')
    }
}